import { render } from "./PhotoUpload.vue?vue&type=template&id=8e01ae3c&scoped=true"
import script from "./PhotoUpload.vue?vue&type=script&lang=js"
export * from "./PhotoUpload.vue?vue&type=script&lang=js"

import "./PhotoUpload.vue?vue&type=style&index=0&id=8e01ae3c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Melissa\\Desktop\\lifehack\\lifehack\\lifehack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e01ae3c"]])

export default __exports__